import { render, staticRenderFns } from "./ListTopic.vue?vue&type=template&id=77e50997&"
import script from "./ListTopic.vue?vue&type=script&lang=ts&"
export * from "./ListTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports